// AuthContext.js
import React, { createContext, useState, useContext, useEffect} from 'react';
import { useNavigate } from 'react-router-dom';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = sessionStorage.getItem('access_token');
   
    console.log(token);
    if (token==='false'||token===null) {
      console.log('false');
      setIsAuthenticated(false);
    }else{
      console.log('true');
      setIsAuthenticated(true);
    }
  }, []);

  const login = (token) => {
    setIsAuthenticated(true);
    sessionStorage.setItem('access_token', token);
  };

  const logout = () => {
    setIsAuthenticated(false);
    sessionStorage.removeItem('access_token');
    navigate('/login', { replace: true });
  };



  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
